/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSeoLocationByPathRetrieveParams } from './model/apiSeoLocationByPathRetrieveParams';
import type { SeoLocation } from './model/seoLocation';

/**
 * SEO Location View for the BrandLocalityService at a page path
 */
export const apiSeoLocationByPathRetrieve = (
  params: ApiSeoLocationByPathRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocation>({ url: `/api/v7/seo-location/`, method: 'GET', params, signal });
};

export const getApiSeoLocationByPathRetrieveQueryKey = (
  params?: ApiSeoLocationByPathRetrieveParams
) => {
  return [`/api/v7/seo-location/`, ...(params ? [params] : [])] as const;
};

export const getApiSeoLocationByPathRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSeoLocationByPathRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>> = ({
    signal,
  }) => apiSeoLocationByPathRetrieve(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSeoLocationByPathRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>
>;
export type ApiSeoLocationByPathRetrieveQueryError = ErrorType<unknown>;

export function useApiSeoLocationByPathRetrieve<
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationByPathRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
